import { graphql } from 'gql';

export const uerRollbackWorkOrderChangeGql = graphql(`
    mutation uerRollbackWorkOrderChange($workOrderId: Long!) {
        uerRollbackWorkOrderChange(workOrderId: $workOrderId) {
            hasValidation
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
